/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product group.
 */
import { mapGetters } from 'vuex';
import productPackagingService from '../../../../services/productPackaging';
import packagingMaterialService from '../../../../services/packagingMaterial';
import packagingTypeService from '../../../../services/packagingType';
import materialService from './../../../../services/material';
import exciseGroupService from './../../../../services/exciseGroup';
import productPackagingTransformer from './../../../../transformers/productPackaging';
import Forms from './../../../../utils/forms/forms';

export default {
  props: {
    onClose: {
      required: false,
      type: Function,
      default: null,
    },
    suggestedData: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        volume: {
          value: '',
          type: 'text',
        },
        qtyInCrate: {
          value: '',
          type: 'number',
        },
        packagingTypeId: {
          value: '',
          type: 'select',
        },
        packagingMaterialId: {
          value: '',
          type: 'select',
        },
        materialId: {
          value: '',
          type: 'select',
        },
        crateMaterialId: {
          value: '',
          type: 'select',
        },
      }),
    };
  },

  created() {
    Promise.all([
      productPackagingService.all(),
      packagingMaterialService.all(),
      packagingTypeService.all(),
      exciseGroupService.all(),
      materialService.all(),
    ]).then(() => {
      this.loading = false;
      if (!this.hasProduction) {
        this.form.hideField('materialId');
        this.form.hideField('crateMaterialId');
      }
    });
    if (this.suggestedData) {
      this.form.assignData({
        name: `${this.suggestedData.packagingName} - ${this.suggestedData.bottleVolume}`,
        volume: this.suggestedData.bottleVolume,
        qtyInCrate: this.suggestedData.packagingQuantity,
        packagingMaterialId: this.suggestedData.packagingMaterialId,
      });
    }
  },

  computed: {
    isInOwnRoute() {
      return this.$route.name === 'productPackagings.create';
    },
    ...mapGetters({
      productPackagings: 'allProductPackagings',
      packagingMaterials: 'allPackagingMaterials',
      packagingTypes: 'allPackagingTypes',
      groups: 'allExciseGroups',
      materials: 'allMaterials',
      account: 'account',
    }),
    hasProduction() {
      if (this.account.modules.length > 0) {
        return this.account.modules.find(
          module => module.name === 'Production'
        );
      }
      if (this.account.allowProducerBatches) return true;

      return false;
    },
  },

  watch: {
    packagingMaterials() {
      this.form.setOptions('packagingMaterialId', this.packagingMaterials.all);
    },
    packagingTypes() {
      this.form.setOptions('packagingTypeId', this.packagingTypes.all);
    },
    materials() {
      this.form.setOptions(
        'materialId',
        this.materials
          .filter(m => m.materialType === 'Packaging')
          .map(item => ({ id: item.id, name: item.name }))
      );
      this.form.setOptions(
        'crateMaterialId',
        this.materials
          .filter(m => m.materialType === 'Crates and boxes')
          .map(item => ({ id: item.id, name: item.name }))
      );
    },
  },

  methods: {
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const productPackaging = productPackagingTransformer.send(
        this.form.data()
      );
      productPackagingService
        .store(productPackaging)
        .then(() => {
          this.form.loading = false;
          if (this.isInOwnRoute) {
            this.$message({
              message: this.$t('static.productPackagings.create.success'),
              type: 'success',
            });
            this.$router.push({
              name: 'productPackagings.index',
            });
          } else {
            if (typeof this.onClose === 'function') {
              this.onClose();
            } else {
              this.$emit('close');
            }
            productPackagingService.all();
          }
        })
        .catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productPackagings/create/create.js